// extracted by mini-css-extract-plugin
export default {"sidebar":"_2bn4wbv22luQ9XkzqqQIbM"};